import type { VideoUploaderFormFields } from "..";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { BooleanField } from "@circle-react-shared/BuilderUI/Editor/fields/BooleanField";
import { ImagePicker } from "@circle-react-shared/BuilderUI/Editor/fields/ImagePicker";
import { Form } from "@circle-react-uikit/Form";

export interface CustomCoverImagePickerProps {
  name: string;
}

export const CustomCoverImagePicker = ({
  name,
}: CustomCoverImagePickerProps) => {
  const { watch, setValue } = useFormContext<VideoUploaderFormFields>();

  const signed_id = watch(`${name}.signed_id`, "");
  const isHasCustomCoverImageDisabled = Boolean(!signed_id);

  const hasCustomCoverImage = watch(`${name}.hasCustomCoverImage`, false);

  const onDeleteCustomImageHandler = () => {
    // eslint-disable-next-line no-alert -- TODO: Replace with a modal
    const isConfirmed = confirm(
      t("builder_ui.prop_type.video_upload.remove_cover_confirmation"),
    );
    if (!isConfirmed) {
      return;
    }
    setValue(`${name}.customCoverImage`, null);
    setValue(`${name}.hasCustomCoverImage`, false);
  };

  return (
    <div className="flex flex-col gap-4">
      <BooleanField
        name={`${name}.hasCustomCoverImage`}
        label={t("builder_ui.prop_type.video_upload.custom_cover_image")}
        isDisabled={isHasCustomCoverImageDisabled}
      />

      {hasCustomCoverImage && (
        <Form.Item
          name={`${name}.customCoverImage`}
          hideLabel
          hideDescription
          hideBorder
          className="!p-0"
        >
          <ImagePicker
            name={`${name}.customCoverImage`}
            shouldAllowRemovingImage
            onDelete={onDeleteCustomImageHandler}
          />
        </Form.Item>
      )}
    </div>
  );
};
